import { useCallback } from 'react';

import { generatePath } from 'react-router-dom';

/**
 * Signals that the customer asked to link an account, rather than simply being routed
 * to the Linked Accounts page. money-ui reads this and applies its own rule: customers
 * with one product go straight into the partner linking flow, customers with both are
 * shown the product chooser. Keeping that decision in money-ui avoids duplicating the
 * entitlement logic here.
 */
export const LINK_INTENT = 'link';

export default function useRedirectToLinkedAccounts(businessEntityUuid) {
  const linkedAccountsPath = generatePath(
    '/dashboard/:businessEntityUuid/finances/linked-accounts',
    {
      businessEntityUuid
    }
  );

  const redirectToLinkedAccounts = useCallback(
    ({ navigate, useTopWindow = false, intent } = {}) => {
      if (!businessEntityUuid) {
        return false;
      }

      const target =
        intent === LINK_INTENT ? `${linkedAccountsPath}?action=${LINK_INTENT}` : linkedAccountsPath;

      if (useTopWindow) {
        window.top.location.href = target;
        return true;
      }

      if (typeof navigate === 'function') {
        navigate(target);
        return true;
      }

      window.location.href = target;
      return true;
    },
    [businessEntityUuid, linkedAccountsPath]
  );

  return {
    linkedAccountsPath,
    redirectToLinkedAccounts
  };
}
